export default __webpack_public_path__ + "static/6-85ed18ee69af8f94bd2dfffe3f2d34b9.webp";